import Vue from 'vue'
import Router from 'vue-router'
//
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta: {
        title: '招标采购行业信用平台 - 全国免费查询企业工商信息', keepAlive: true,
      },
      component: resolve => (require(['@/views/index/index.vue'], resolve)),
    },
    {
      path: '/company',
      name: 'Company',
      meta: {
        title: '企业详情',
      },
      component: resolve => (require(['@/views/company/index.vue'], resolve)),
    },
    {
      path: '/personCenter',
      name: 'PersonCenter',
      meta: {
        title: '账户管理',
      },
      component: resolve => (require(['@/views/personCenter/index.vue'], resolve)),
    },
    {
      path: '/fourEssential',
      name: 'FourEssential',
      meta: {
        title: '企业工商四要素核验',
        footerHide: true
      },
      component: resolve => (require(['@/views/fourEssential/index.vue'], resolve)),
    },
    {
      path: '/fileSimilarity',
      name: 'FileSimilarity',
      meta: {
        title: '投标文件相似性分析',
        footerHide: true
      },
      component: resolve => (require(['@/views/fileSimilarity/index.vue'], resolve)),
    },
    {
      path: '/prefixReport',
      name: 'PrefixReport',
      meta: {
        title: '投标企业前置资格信息查询',
        footerHide: true
      },
      component: resolve => (require(['@/views/prefixReport/index.vue'], resolve)),
    },
    {
      path: '/creditReport',
      name: 'CreditReport',
      meta: {
        title: '招投标行业企业信用',
        footerHide: true
      },
      component: resolve => (require(['@/views/creditReport/index.vue'], resolve)),
    },
    {
      path: '/customized',
      name: 'Customized',
      meta: {
        title: '私人订制',
        footerHide: true
      },
      component: resolve => (require(['@/views/customized/index.vue'], resolve)),
    },
    {
      path: '/standingReport',
      name: 'StandingReport',
      meta: {
        title: '企业行业地位分析',
        footerHide: true
      },
      component: resolve => (require(['@/views/standingReport/index.vue'], resolve)),
    },
    {
      path: '/analyzePush',
      name: 'AnalyzePush',
      meta: {
        title: '潜在供应商分析',
        footerHide: true
      },
      component: resolve => (require(['@/views/analyzePush/index.vue'], resolve)),
    },
    {
      path: '/relevanceReport',
      name: 'RelevanceReport',
      meta: {
        title: '投标人关联关系',
        footerHide: true
      },
      component: resolve => (require(['@/views/relevanceReport/index.vue'], resolve)),
    },
    {
      path: '/integrityAndDishonesty',
      name: 'IntegrityAndDishonesty',
      meta: {
        title: '诚信点赞/失信差评'
      },
      component: resolve => (require(['@/views/integrityAndDishonesty/index.vue'], resolve)),
    },
    {
      path: '/selfDisciplineConventions',
      name: 'SelfDisciplineConventions',
      meta: {
        title: '行业自律公约签署'
      },
      component: resolve => (require(['@/views/selfDisciplineConventions/index.vue'], resolve)),
    },
    {
      path: '/distortionQuestioning',
      name: 'DistortionQuestioning',
      meta: {
        title: '失真质疑'
      },
      component: resolve => (require(['@/views/distortionQuestioning/index.vue'], resolve)),
    },
    {
      path: '/performanceSupplement',
      name: 'PerformanceSupplement',
      meta: {
        title: '业绩补充'
      },
      component: resolve => (require(['@/views/performanceSupplement/index.vue'], resolve)),
    },


    {
      path: '/page/web/ali-pay-empty.html',
      name: 'score-explain',
      meta: {
        title: '支付宝支付的回调页面',
      },
      component: resolve => (require(['@/views/aliPaySuccess/index.vue'], resolve)),
    },
    /* 手机端访问 */
    {
      path: '/phone/pages/score-explain.html',
      name: 'score-explain',
      meta: {
        title: '等级分值释义',
        phone: true
      },
      component: resolve => (require(['@/views/index/modules/scoreExplain.vue'], resolve)),
    },
    {
      path: '/phone/pages/score-rule.html',
      name: 'score-rule',
      meta: {
        title: '等级分值释义',
        phone: true
      },
      component: resolve => (require(['@/views/index/modules/scoreRule.vue'], resolve)),
    },
    {
      path: '/phone/pages/annual-reports.html',
      name: 'annual-reports',
      meta: {
        title: '企业年报',
        phone: true
      },
      component: resolve => (require(['@/components/annualReports/index.vue'], resolve)),
    },
    /* 提供给赵顺给省交录入数据 */
    {
      path: '/test/relevanceReport',
      name: 'TestRelevanceReport',
      meta: {
        title: '投标人关联关系',
        footerHide: true
      },
      component: resolve => (require(['@/views/test/relevanceReport.vue'], resolve)),
    },
    {
      path: '/test/prefixReport',
      name: 'TestPrefixReport',
      meta: {
        title: '投标人关联关系',
        footerHide: true
      },
      component: resolve => (require(['@/views/test/prefixReport.vue'], resolve)),
    },
  ],
  mode: 'history',
})
